import { BaseContainerModel } from "../../base-container.model";
import { bl_alg_cc_endpoint_bot_link_RowClass } from "../../../dbschema";

export class EndpointBotLinkContainerModel extends BaseContainerModel{
  bl_alg_cc_endpoint_bot_link: bl_alg_cc_endpoint_bot_link_RowClass = new bl_alg_cc_endpoint_bot_link_RowClass();
}
